import { workoutProgramWithDescriptions } from 'fitbeat.gym-core';
import { ProgramType, IEnabledFeatures } from 'fitbeat.models';
import React from 'react';
import { ScrollView, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import Theme, { ThemeType } from '../../theme';
import { EffortIcon, NutritionIcon, WorkoutClockIcon } from '../../ui';
import { styles as SharedStyles } from '../SignupFormsStyles';
import { LongTermGoalInfoSection } from './LongTermGoalInfoSection';
import { LongTermGoalTile } from './LongTermGoalTile';
import { defaultScale } from '../../utils/scaling';
import { connect } from 'react-redux';
import { enabledFeaturesSelector } from '../../auth';


interface IProps {
  longTermGoal: ProgramType;
  theme: ThemeType;
  enabledFeatures: IEnabledFeatures;
  useBackgroundForGoalHeader?: boolean;
  goalTileContainerStyle?: StyleProp<ViewStyle>;
  onPress?(): void;
}

const LongTermGoalDescriptionComponent = ({
  longTermGoal,
  theme = ThemeType.dark,
  enabledFeatures,
  useBackgroundForGoalHeader = false,
  goalTileContainerStyle }: IProps) => {
  const programGoalWithDescription = workoutProgramWithDescriptions(enabledFeatures).find(
    (programDescriptions) => programDescriptions.programType === longTermGoal
  );

  const backgroundColor = theme === ThemeType.dark ? Theme.GREY_DARK : Theme.WHITE;
  const iconColor = theme === ThemeType.dark ? Theme.WHITE : Theme.BLACK;
  const separatorColor = theme === ThemeType.dark ? Theme.GREY_DARK_MEDIUM : Theme.GREY_MEDIUM_LIGHT;
  return (
    <>
      <View style={goalTileContainerStyle}>
        <LongTermGoalTile
          useInline={false}
          theme={theme}
          programType={longTermGoal}
          useBackgroundForGoalHeader={useBackgroundForGoalHeader}
        />
      </View>
      <ScrollView style={[SharedStyles.container, styles.goalListContainer, { backgroundColor }]}>
        {programGoalWithDescription &&
          <>
            <LongTermGoalInfoSection
              theme={theme}
              icon={
                <WorkoutClockIcon
                  color={iconColor}
                  width={defaultScale(28)}
                  height={defaultScale(35)}
                />
              }
              title={'Workouts'}
              description={programGoalWithDescription.onBoardingWorkoutDescription}
            />
            <View style={[styles.separator, { backgroundColor: separatorColor }]} />
            <LongTermGoalInfoSection
              theme={theme}
              icon={
                <NutritionIcon
                  color={iconColor}
                  width={defaultScale(28)}
                  height={defaultScale(35)}
                />
              }
              title={'Nutrition'}
              description={programGoalWithDescription.onBoardingNutritionDescription}
            />
            <View style={[styles.separator, { backgroundColor: separatorColor }]} />
            <LongTermGoalInfoSection
              theme={theme}
              icon={
                <EffortIcon color={iconColor}
                  width={defaultScale(28)}
                  height={defaultScale(35)}
                />
              }
              title={'Tracking'}
              description={programGoalWithDescription.onBoardingTrackingDescription}
            />
          </>
        }
      </ScrollView>
    </>
  );
};

const mapStateToProps = (state) => ({
  enabledFeatures: enabledFeaturesSelector(state),
});

export const LongTermGoalDescription = connect(mapStateToProps)(LongTermGoalDescriptionComponent);

const styles = StyleSheet.create({
  goalListContainer: {
    flex: 1,
    marginTop: defaultScale(-20),
    paddingHorizontal: defaultScale(20),
    backgroundColor: Theme.GREY_DARK,
  },
  iconStyle: {
    width: defaultScale(28),
    height: defaultScale(35),
  },
  separator: {
    height: defaultScale(1),
    flex: 1,
    backgroundColor: Theme.GREY_MEDIUM_LIGHT,
  },
});
